import { useCallback } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { derivePersona, type PersonaKey } from '@/shared/domain'
import { useOrgContext } from '@/shared/ui/hooks'
import { isPathVisibleForPersona, moduleRootFromPath } from './nav-visibility'

const DASHBOARD_PATH = '/dashboard'

function personaForOrg(
  memberships: ReturnType<typeof useOrgContext>['memberships'],
  orgId: string | null,
): PersonaKey | null {
  const target =
    (orgId !== null ? memberships.find((m) => m.orgId === orgId) : undefined) ?? memberships[0]
  if (!target) return null
  return derivePersona(target.orgType, target.role)
}

export function usePersonaSwitchNavigation(): (orgId: string | null) => void {
  const ctx = useOrgContext()
  const navigate = useNavigate()
  const location = useLocation()

  return useCallback(
    (orgId: string | null) => {
      const nextPersona = personaForOrg(ctx.memberships, orgId)
      const moduleRoot = moduleRootFromPath(location.pathname)
      ctx.selectOrg(orgId)
      const destination =
        nextPersona !== null && isPathVisibleForPersona(location.pathname, nextPersona)
          ? moduleRoot
          : DASHBOARD_PATH
      if (destination !== location.pathname) {
        navigate(destination)
      }
    },
    [ctx, navigate, location.pathname],
  )
}
